import { ChevronRightIcon } from '@heroicons/react/20/solid'

import { useEnhancedNavigate } from '../../../common/hooks'
import { MainPathEnum, SubPathEnum } from '../../../common/types/routing'
import { SubSearchParamEnum } from '../../../common/types/searchParams'
import type { ProcessAnalysisConfig } from '../types'
import TrackedProcessCardLead from './TrackedProcessCardLead'

interface Props {
  process: ProcessAnalysisConfig
}

const TrackedProcessName = ({ process }: Props) => {
  const { enhancedNavigate: navigate } = useEnhancedNavigate()

  const processLink = `${MainPathEnum.PROCESSES}/${process.id}/${SubPathEnum.OVERVIEW}`
  const activeFilterId = process.active_filter_id

  const openProcess = () => {
    navigate(`../${processLink}`, {
      search: `?${SubSearchParamEnum.PROCESS_FILTER}=${activeFilterId}`,
    })
  }

  return (
    <button
      type='button'
      onClick={openProcess}
      className='group flex w-full flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-slate-200/90 bg-white px-4 py-3 text-left shadow-sm ring-offset-2 transition hover:border-primary-300 hover:bg-primary-50/40 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500'
    >
      <TrackedProcessCardLead process={process} />

      <ChevronRightIcon
        className='size-5 shrink-0 text-slate-300 transition group-hover:translate-x-0.5 group-hover:text-primary-600'
      />
    </button>
  )
}

export default TrackedProcessName

